import React, { useEffect, useReducer } from 'react'
import { AgentsSection, DatesSection, OtherDetailsSection, ReferralSection } from './Utilities';
import { TrackEventService } from '../../../../../../Helper/mixpanelHelper';

export const ReservationDetailsTab = (props) => {


  // useEffect(() => {
  //   //todo:: this should be filled on next button clicked 
  //   onSelectedChanged(prevState => ({
  //     ...prevState, 
  //     ...localSelected,
  //   }))
  // }, [localSelected]);
  // useEffect(() => {
  //   //todo:: this should be filled on next button clicked 
  //   onLocalSelectedChange({id: 'edit' , value: selected})

  // }, [selected]);

     useEffect(() => {
        //Traking Event
        TrackEventService('Leasing_journey_Transaction_Execution_Lease_Details_Clicked', { page_name: 'Leasing Journey', screen: 'Transaction_Execution' });
   }, []);

     useEffect(() => {
        //Traking Event
        TrackEventService('Leasing_journey_Transaction_Execution_Lease_Details_Clicked', { page_name: 'Leasing Journey', screen: 'Transaction_Execution' });
   }, []);


        useEffect(() => {
        //Traking Event
        TrackEventService('Leasing_journey_Unit_Reservation_Agreement_Details_Clicked', { page_name: 'Leasing Journey', screen: 'Transaction_Execution' });
   }, []);

   


  return (
    <div className='w-75'>
      <AgentsSection
        {...props}
      />
      <ReferralSection
        {...props}
      />
      <DatesSection
        {...props}
      />
      <OtherDetailsSection
        {...props}
      />
    </div>
  )
}
